import { Box, Typography } from '@mui/material'
import { format } from 'date-fns'
import theme from 'lib/theme'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const WeekHeader = ({ label, date }: { label: string; date: Date }) => {
  const today = format(new Date(), 'dd-MM-yyyy')
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        borderTop: 'none',
        padding: theme.spacing(1),
        paddingBottom: theme.spacing(2),
      }}>
      <Typography
        sx={{
          color:
            format(date, 'dd-MM-yyyy') === today
              ? theme.palette.primary.main
              : theme.palette.text.secondary,
          fontSize: '10px',
        }}>
        {t(label.split(' ')[1]).toUpperCase()}
      </Typography>
      <Typography
        sx={{
          color:
            format(date, 'dd-MM-yyyy') === today
              ? theme.palette.primary.main
              : theme.palette.text.secondary,
          fontSize: '24px',
        }}>
        {label.split(' ')[0]}
      </Typography>
    </Box>
  )
}
